import { makeStyles } from '@material-ui/core/styles';

export const useListReaderRequestsStyles = makeStyles(theme => ({
  request: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  modal: {
    '& .MuiDialog-paperFullWidth': {
      minWidth: '40rem'
    },
    '& .MuiDialogTitle-root .MuiSvgIcon-root': {
      display: 'none'
    }
  }
}));
